"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fieldList_1 = require("./fieldList");
var getterCache = {};
getterCache.undefined = function () { return undefined; };
/**
 * Can be used for getting value from object using field path. For example `users[index].name`.
 * @example
 * ```jsx-no-run
 * const values = {users:[{lastName: 'Doe'}]};
 * const firstUserLastName = getter('user[0].lastName');
 *
 * console.log(firstUserLastName(values))
 *
 * // result: 'Doe'
 * ```
 */
function getter(field) {
    if (getterCache[field]) {
        return getterCache[field];
    }
    var fields = fieldList_1.fieldList(field);
    getterCache[field] = function (obj) {
        var result = obj;
        for (var idx = 0; idx < fields.length && result; idx++) {
            result = result[fields[idx]];
        }
        return result;
    };
    return getterCache[field];
}
exports.getter = getter;
//# sourceMappingURL=getter.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-common@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-common/dist/npm/getter.js
// module id = 6466
// module chunks = 0